import { BaseDropdown } from './component/BaseDropdown';
import { useDropdownOptions } from '../../hooks/useDropdownOptions';
import { BusinessDropdownProps } from './component/type';

const COLUMN_NAMES = ['Departure Id', 'Description'];

export const AddressDepartureDropdown = (props: BusinessDropdownProps) => {
  const shouldPreventApiCall = props.disabled || props.readOnly;

  const { options, loading } = useDropdownOptions({
    apiId: 'internal.v1.base-tables',
    operationId: 'GET /promptValues/{windowId}',
    labelAttribute: 'description',
    valueAttribute: 'departureId',
    params: { windowId: 'departures' },
    shouldPreventApiCall,
  });

  return <BaseDropdown {...props} loading={loading} options={options} columnNames={COLUMN_NAMES} />;
};
